import { connect } from "react-redux";
import { getConnDeviceStatus } from "redux-store/connection/selectors";

import { WsDeviceStatusConnStatus } from "./ws-ds-conn-status";

function mapStateToProps(state) {
  return {
    deviceStatusOnline: getConnDeviceStatus(state),
  };
}

const ConnectedWsDeviceStatusConnStatus = connect(mapStateToProps)(
  WsDeviceStatusConnStatus,
);

export { ConnectedWsDeviceStatusConnStatus };
